import React from 'react'
import isToday from 'date-fns/isToday'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import { DATE_FORMAT } from '../../constants/date'
import './styles.css'
import StatusTag from '../../components/StatusTag'
import { SpaceStatus } from '../../components/StatusTag'

export default function Availability({
  space,
  border = false,
  containerStyle = {},
}) {
  if (!space) {
    return null
  }
  const { reservable } = space
  let occupancyStatus = 3
  // const label = status === 'Sent' ? 'Pending' : 'Expired'

  let availabilityText = ''

  if (reservable && reservable.uuid) {
    if (
      reservable.status === 'occupied' &&
      reservable.reservations.length > 0
    ) {
      occupancyStatus = SpaceStatus.OCCUPIED
      if (reservable.officeHold) {
        occupancyStatus = SpaceStatus.ONHOLD
      }
    } else if (reservable.availability && reservable.availability.length) {
      const date = parseISO(reservable.availability)
      if (isToday(date)) {
        availabilityText = 'Today'
        occupancyStatus = SpaceStatus.AVAILABLE
      } else {
        occupancyStatus = SpaceStatus.AVAILABLE
        availabilityText = `on ${format(
          parseISO(reservable.availability),
          DATE_FORMAT.DATE
        )}`
      }
    }
  }
  if (occupancyStatus !== SpaceStatus.AVAILABLE) {
    return null
  }
  return (
    <div
      style={{
        position: 'relative',
        padding: 16,
        borderRadius: '.25rem',
        border: border ? '1px solid #E6E6E6' : 0,
        ...containerStyle,
      }}
    >
      <StatusTag status={occupancyStatus} text={availabilityText} />
      {/* <Chip
        className={statusClass}
        basic={false}
        circular={false}
        style={{
          borderRadius: 0,
          color: 'black',
        }}
        // as="<div/"
        // color="black"
        size="tiny"
      >
        {status}
      </Chip> */}
      {/* {availabilityText && (
        <>
          <Text style={{ fontWeight: '600', marginTop: 16 }} size="tiny">
            Available
          </Text>
          <Text size="tiny" style={{ marginBottom: 16 }}>
            {availabilityText || '-'}
          </Text>
        </>
      )} */}
      {/* <Text style={{ fontWeight: '600' }} size="tiny">
        Last occupied (static)
      </Text>
      <Text size="tiny">3 months ago</Text> */}
    </div>
  )
}
